<div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full">
  <app-search-on-select
    class="input md:w-[20%] min-w-[20%] w-full"
    [parentFormGroup]="form"
    [options]="groupOptions.list"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['groupId']"
    controlName="groupId"
    label="Group"
    placeholder="Select all that apply"
    type="small"
    (onNextPage)="groupOnNextPage()"
    [enableMultiple]="true"
    [loading]="groupOptions.loading"
    [hasNext]="groupOptions.hasNext"
    filterControlName="searchGroup"
    [enableClearSelection]="true"
    optionsPanelClassName="clients-dropdown"
  ></app-search-on-select>
  <app-dropdown
    class="input md:w-[20%] min-w-[20%] w-full"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['role']"
    [options]="roleFilterList"
    [enableMultiple]="true"
    [enableClearSelection]="true"
    controlName="role"
    label="Role"
    placeholder="Select all that apply"
    type="small"
  />
  <app-dropdown
    class="input md:w-[20%] min-w-[20%] w-full"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['status']"
    [options]="statusFilterList"
    [enableMultiple]="true"
    [enableClearSelection]="true"
    controlName="status"
    label="Status"
    placeholder="Select all that apply"
    type="small"
  />

  <div class="vertical hidden md:block"></div>

  <app-text-input
    class="input w-full md:w-[20%] min-w-[20%] search-input"
    [parentFormGroup]="form"
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['searchText']"
    (handleSuffixClick)="apply()"
    suffixIcon="search"
    controlName="searchText"
    label="Search"
    placeholder="Search by name"
    type="small"
    [minLength]="0"
  ></app-text-input>

  <div class="vertical hidden md:block"></div>

  <app-primary-button
    type="small"
    class="btn lg:w-[10%] md:w-[10%] w-full"
    (handleClick)="apply()"
    [isDisabled]="!form.dirty"
  >
    Apply
  </app-primary-button>
</div>
